import { Component, Input } from '@angular/core';
import { LoginService } from '../../services/login/login.service';
/**ToDo Documentazione */
@Component({
  selector: 'app-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html'
})
export class HeaderComponent {

  @Input() public iter: any;
  @Input() public lastUpdate: any;
  @Input() public logoAdv: any; 
  @Input() public logoTourOperator: any; 
  @Input() public selectLanguageView: any; 
  @Input() public consolidator: any;
  @Input() public isTravelAgency: any;
  /** Colore di sfondo barra superiore (tenant `topBarColor`); assente ⇒ invariata. */
  @Input() public topBarColor: any;
  /** Tenant `menuConfiguration.mobileInfoVisible`: false ⇒ su mobile logo a sx, hamburger a dx, info nel collapse. */
  @Input() public mobileInfoVisible: boolean = true;

  constructor(private readonly loginService: LoginService) {}

  public isLoggedIn(): boolean {
    return this.loginService.isLoggedIn();
  }

  public getUserRole(): string{
    return this.loginService.getUserRole();
  }

}
